export default __webpack_public_path__ + "static/media/search-no-results-1x.6d060fe0.png";